export default {
  isAuthenticated: (state) => {
    return !!state.token
  },
  firstAccess: (state) => state.firstAccess
}
